import Text from "@/components/Text";
import styled from "styled-components";

const HeatmapCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  padding: 24px;
  padding-left: 16px;
  padding-bottom: 16px;
  margin-bottom: 16px;
`;

const HeatmapHolder = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const HeatmapGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  grid-gap: 5px;
  flex: 1;
`;

const DataPoint = styled.div`
  background: rgba(240, 173, 28, 0.6);
  border-radius: 4px;
  width: 100%;
  height: 100%;
  height: 22px;
`;

const HeatmapDays = styled.div`
  width: 27px;
  display: grid;
  margin-right: 5px;
  align-content: center;
  > p {
    display: flex;
    align-items: center;
    height: 22px;
  }
  grid-gap: 5px;
`;

const HeatmapHours = styled.div`
  display: grid;
  grid-template-columns: 27px repeat(24, 1fr);
  grid-gap: 5px;
  margin-top: 12px;
  text-align: center;
`;

const PercentageBox = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  padding: 32px 24px 16px 48px;
  grid-template-columns: 5fr 4fr 1fr;
  grid-template-rows: 22px auto;
  display: grid;
  grid-column-gap: 5px;
  grid-row-gap: 10px;
`;

const FreshBox = styled.div`
  background: ${({ theme }) => theme.colors.warning};
  border-radius: 4px;
`;

const DistributionBox = styled.div`
  background: rgba(240, 173, 28, 0.6);
  border-radius: 4px;
`;

const ReuseBox = styled.div`
  background: rgba(240, 173, 28, 0.2);
  border-radius: 4px;
`;

const Heatmap = () => {
  return (
    <>
      <HeatmapCard>
        <HeatmapHolder>
          <HeatmapDays>
            <Text $type="extraSmall" $color="gray">
              Mon
            </Text>
            <Text $type="extraSmall" $color="gray">
              Tue
            </Text>
            <Text $type="extraSmall" $color="gray">
              Wed
            </Text>
            <Text $type="extraSmall" $color="gray">
              Thu
            </Text>
            <Text $type="extraSmall" $color="gray">
              Fri
            </Text>
            <Text $type="extraSmall" $color="gray">
              Sat
            </Text>
            <Text $type="extraSmall" $color="gray">
              Sun
            </Text>
          </HeatmapDays>
          <HeatmapGrid>
            {[...Array(168)].map((x, i) => (
              <DataPoint key={i} />
            ))}
          </HeatmapGrid>
        </HeatmapHolder>
        <HeatmapHours>
          <span></span>
          {[...Array(24)].map((x, i) => (
            <Text $type="extraSmall" $color="gray" key={i}>
              {i < 9 ? `0${i + 1}:00` : `${i + 1}:00`}
            </Text>
          ))}
        </HeatmapHours>
      </HeatmapCard>
      <PercentageBox>
        <FreshBox />
        <DistributionBox />
        <ReuseBox />
        <Text $type="extraSmall" $color="gray">
          Fresh: 50%
        </Text>
        <Text $type="extraSmall" $color="gray">
          Distribution: 40%
        </Text>
        <Text $type="extraSmall" $color="gray">
          Reuse: 10%
        </Text>
      </PercentageBox>
    </>
  );
};

export default Heatmap;
